<template>
  <el-container class="BedRearrangement">
    <el-header>
      <span style="margin-left: 20px">床位数量:{{ bedTotal }}张</span>
      <span style="margin-left: 20px">入住:{{ Number(checkIn)+Number(tryIn) }}张</span>
      <span style="margin-left: 20px">空床:{{ nullBed }}张</span>
      <span style="margin-left: 20px">已预约:{{ order }}张</span>
      <span style="margin-left: 20px">待缴费:{{ noFee }}张</span>
      <span style="margin-left: 20px">
        楼栋：
        <el-select
          v-model="buildingName"
          placeholder="请选择"
          style="width: 150px"
          @change="changeBuild"
        >
          <el-option
            v-for="item in builList"
            :key="item.value"
            :label="item.buildingName"
            :value="item.buildingId"
          ></el-option>
        </el-select>
      </span>
      <span style="margin-left: 30px">
        楼层:
        <el-select
          v-model="floorNo"
          placeholder="请选择"
          style="width: 150px"
          @change="changeFloor"
        >
          <el-option
            v-for="item in floorList"
            :key="item.floorNo"
            :label="item.floorNo"
            :value="item.floorNo"
          ></el-option>
        </el-select>
      </span>
      <el-button
        type="primary"
        v-if="!isEdit"
        @click="edit"
        style="margin-left: 40px"
        plain
        >编辑</el-button
      >
      <el-button
        type="warning"
        v-else
        @click="back"
        style="margin-left: 40px"
        plain
        >完成</el-button
      >
      <el-button
        v-if="isEdit"
        @click="cancel"
        style="margin-left: 40px"
        plain
        >取消</el-button
      >
    </el-header>
    <div style="display: flex; flex-wrap: wrap">
      <div class="roomList" v-for="item in roomList" :key="item">
        <div class="header">{{ item.roomNo }}</div>
        <div class="containt">
          <div
            style="display: flex; justify-content: space-between; height: 33px"
          >
            <p>房间编号</p>
            <p>{{ item.roomNo }}</p>
          </div>
          <div class="bedList">
            <div class="bed" v-for="item1 in item.bedList" :key="item1">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <p v-if="!isEdit">{{ item1.bedNo }}</p>
                <input
                  v-model="item1.bedNo"
                  v-else
                  type="text"
                  style="width: 20px"
                  maxlength="3"
                  oninput="value=value.replace(/[^\d]/g,'')"
                />
                <p>号床</p>
              </div>
              <img
                src="@/assets/beadhouse/nan.png"
                style="display: inline-block; vertical-align: middle"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>
<script>
export default {
  name: "BedRearrangement",
  data() {
    return {
      isEdit: false,
      builList: [], //选择框楼栋信息
      buildingName: "",
      floorList: [],
      floorNo: "",
      buildingId: 0,
      roomList: [],
      checkIn: 0,
      nullBed: 0,
      bedTotal: 0,
      order: 0,
      noFee: 0,
      tryIn: 0,
    };
  },
  methods: {
    /* 
      获取入住信息
    */
    getIntoDetail() {
      let date = new Date().getMonth() + 1;
      if (date < 10) {
        date = "0" + date;
      }
      this.$postForm("omc/Bed/queryBedStatus/0").then((res) => {
        let allCout = 0;
        res.result.forEach((item) => {
          if (item.status == 0) {
            this.nullBed = item.count;
          } else if (item.status == 2) {
            this.checkIn = item.count;
          } else if (item.status == 3) {
            this.order = item.count;
          } else if (item.status == 7) {
            this.noFee = item.count;
          } else if (item.status == 5) {
            this.tryIn = item.count;
          }
          allCout += item.count;
        });
        this.bedTotal = allCout;
      });
    },

    /* 
        编辑按钮
      */
    edit() {
      this.isEdit = true;
    },

    /* 
      取消按钮
    */
    cancel() {
      this.isEdit = false;
      this.getBedView();
    },
    /* 完成按钮 */
    back() {
      let bedList = [];
      //将参数提取出来
      for (var i = 0; i < this.roomList.length; i++) {
        for (var k = 0; k < this.roomList[i].bedList.length; k++) {
          bedList.push(this.roomList[i].bedList[k]);
        }
      }
      //判断床位号是否有为空的
      let isnoNum = false;
      bedList.forEach((item) => {
        if (!item.bedNo) {
          isnoNum = true;
          return false;
        }
      });
      if (isnoNum) {
        this.$message.error("床位号不能为空");
      } else {
        let param = {
          bedList: bedList,
        };
        this.$postJson("omc/Bed/bedNoReset", param).then((res) => {
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.isEdit = false;
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      }
    },
    /* 
        获取所有楼栋信息
      */
    getbuilAll() {
      this.$postForm("omc/Building/showAlls").then((res) => {
        this.builList = res.result;
      });
    },

    /* 
        选择楼栋
    */
    changeBuild(val) {
      this.isEdit = false;
      this.buildingId = val;
      let currentBiuld = [];
      this.builList.map((item) => {
        if (item.buildingId == val) {
          currentBiuld = item;
        }
      });
      this.floorList = currentBiuld.floorList;
      console.log(this.floorList);
      console.log(this.floorList.floorNo);
      this.floorNo = "请选择";
    },

    /* 
        选择楼层
   */
    changeFloor(val) {
      this.isEdit = false;
      this.floorNo = val;
      this.getBedView();
    },

    /* 
        获取床位视图
    */
    getBedView() {
      let param = {
        buildingId: this.buildingId,
        floorNo: this.floorNo,
      };
      this.$postJson("omc/Bed/queryBedInfo", param).then((res) => {
        if (res.result.length > 0) {
          //处理数据进行去重
          var roomList = [];
          for (var i = 0; i < res.result.length; i++) {
            var roomId = res.result[i].roomId;
            //是否存在改roomId；
            var isHaveRoom = false;
            for (var j = 0; j < roomList.length; j++) {
              if (roomList[j].roomId == roomId) {
                isHaveRoom = true;
              }
            }
            //不存在，则添加room，bedList 首先为空
            if (!isHaveRoom) {
              roomList.push({
                roomId: roomId,
                roomNo: res.result[i].roomNo,
                bedList: [],
              });
            }
            // 获取到roomList 里面的 roomId 的下标
            for (var j = 0; j < roomList.length; j++) {
              if (roomList[j].roomId == roomId) {
                roomList[j].bedList.push(res.result[i]);
              }
            }
          }
          this.roomList = roomList;
          console.log(roomList);
        } else {
          this.roomList = [];
          this.$message({ message: "该楼层暂无房间", type: "error" });
        }
      });
    },
  },
  mounted() {
    this.getbuilAll();
    this.getIntoDetail();
  },
};
</script>
<style  lang="scss" scoped>
.BedRearrangement {
  background: #fff;
  padding: 10px;
  .main {
    display: flex;
    flex-wrap: wrap;
  }
  .roomList {
    width: 260px;
    padding-bottom: 18px;
    border: 2px solid #3a77e2;
    border-radius: 4px;
    margin: 14px 64px 14px 0;

    .header {
      height: 38px;
      background: #3a77e2;
      text-align: center;
      line-height: 38px;
    }
    .containt {
      padding: 0 20px 0 20px;
      .bedList {
        display: flex;
        text-align: center;
        width: 240px;
        flex-wrap: wrap;
        .bed {
          margin-right: 40px;
          margin-left: 12px;
        }
      }
    }
  }
}
</style>